module.exports = __webpack_public_path__ + "img/placeholder1.370b40e2.png";